import { useDisableBodyScroll } from 'hooks/useDisableBodyScroll'
import { CrossIcon, H, Wrapper } from '@farewill/ui'
import styled from 'styled-components'
import { GTR, COLOR, BORDER } from '@farewill/ui/tokens'

const Outer = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.3);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 200;
`

const Inner = styled(Wrapper)`
  max-width: ${({ $maxWidth }) => `${$maxWidth}px`};
  margin: ${GTR.XXL} auto 0;
  overflow-y: auto;
  max-height: calc(100vh - 2 * ${GTR.XXL});
  height: ${({ $fitContent }) =>
    $fitContent ? 'auto' : `calc(100vh - 2 * ${GTR.XXL})`};
`

const Heading = styled(Wrapper)`
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: ${COLOR.WHITE};
  padding: ${GTR.S};
  border-radius: ${BORDER.RADIUS.S} ${BORDER.RADIUS.S} 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  * {
    margin-bottom: 0;
  }
`

const Body = styled(Wrapper)`
  background-color: ${COLOR.BACKGROUND.FOG};
  padding: ${GTR.M} ${GTR.S};
  border-radius: 0 0 ${BORDER.RADIUS.S} ${BORDER.RADIUS.S};
`

const Close = styled.button`
  font-size: 0;
  color: ${COLOR.GREY.MEDIUM};
`

const Modal = ({
  component: Component,
  headingText,
  hideModal,
  visible,
  maxWidth,
  fitContentHeight,
  headingSize,
  ...rest
}) => {
  useDisableBodyScroll({ disable: visible })
  if (!visible) return null
  return (
    <Outer role="dialog" aria-label={headingText}>
      <Inner $maxWidth={maxWidth} $fitContent={fitContentHeight}>
        <Heading>
          {headingSize === 'M' ? (
            <H size="M" tag="h2" margin={0}>
              {headingText}
            </H>
          ) : (
            <h5>{headingText}</h5>
          )}
          <Close onClick={hideModal} type="button">
            <CrossIcon /> Close
          </Close>
        </Heading>
        <Body>
          <Component {...rest} />
        </Body>
      </Inner>
    </Outer>
  )
}

Modal.defaultProps = {
  maxWidth: 450,
}

export default Modal
